import pageableFactory from '@/store/modules/mixins/pageable';

const pageable = pageableFactory();
const defaultState = () => ({
  ...pageable.state,
  pagingLimit: 12,
  selected: [],
});

const templatesModule = {
  namespaced: true,
  state: defaultState(),
  mutations: {
    ...pageable.mutations,
    RESET_STATE(state) {
      Object.assign(state, defaultState());
    },
    SET_SELECTED_TEMPLATES(state, { templates }) {
      state.selected = templates;
    },
  },
  actions: {
    RESET_STATE({ commit }) {
      commit('RESET_STATE');
    },
    PAGINATE: pageable.actions.paginatePartialApplication({
      url: 'templates',
    }),
  },
  getters: {
    ...pageable.getters,
    partiesCount: (state) => {
      let count = 0;
      state.selected.forEach((template) => {
        if (template.parties.length > count) {
          count = template.parties.length;
        }
      });
      return count;
    },
    mergeFields: (state) => {
      const fields = [];
      state.selected.forEach((template) => {
        fields.push(...template.fields.filter(field => field.merge_field !== ''));
      });
      return fields;
    },
    mergeFieldsForParty: (state, getters) => (id) => {
      const partyId = parseInt(id, 10);
      return getters.mergeFields.filter(field => parseInt(field.party_id, 10) === partyId);
    },
    fieldsForPartyTemplate: state => (id) => {
      const fields = [];
      const partyId = parseInt(id, 10);
      state.selected.forEach((template) => {
        fields.push(...template.fields.filter(field => field.merge_field === ''));
      });
      return fields.filter(field => parseInt(field.party_id, 10) === partyId);
    },
  },
};

export default templatesModule;
